// extracted by mini-css-extract-plugin
export var icon = "_d-1";
export var subtext = "_d-0";